import Alert from '@mui/material/Alert';
import Main from './main';

type Props = {
  message?: string;
  error?: { message?: string };
  compact?: boolean;
};

const ErrorMessage = ({ message, error, compact = false }: Props) => {
  if (error) {
    console.log(error);
  }

  const content = (
    <Alert severity="error">{message}</Alert>
  );

  if (compact) {
    return content;
  }

  return (
    <Main compact>
      {content}
    </Main>
  );
};

export default ErrorMessage;
